import styled from "styled-components";
import { fontBold, fontNormal } from "../Typography";
import buildColor from "../ColorPalette";

const PromosLegalsContainer = styled.div`
  padding: 24px 12px;
  font-family: ${fontNormal};
  font-size: 12px;
  line-height: 14px;
  color: ${buildColor("grey", "600")};
  margin: 0 auto;

  strong,
  b {
    font-family: ${fontBold};
  }

  div,
  p,
  span {
    font-family: ${fontNormal};
  }

  a {
    font-family: ${fontNormal};
    color: ${buildColor("blue", "500")};
    display: inline-block;
    vertical-align: baseline;
  }

  @media only screen and (min-width: 800px) {
    max-width: 750px;
    padding: 24px 0 0;

    &.legalsTopOffset {
      padding: 0 0 24px;
    }
  }

  @media only screen and (min-width: 600px) and (max-width: 799px) {
    max-width: 624px;
    padding: 24px 0 0;

    &.legalsTopOffset {
      padding: 0 0 24px;
    }
  }
`;

export default PromosLegalsContainer;
